import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../common';
import { IAdminScreenDetail, IOOHScreen, IOOHScreenResponse } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {

  constructor(private http: HttpClient) { }

  // ✅ API TO FETCH ALL OOH SCREENS
  getOOHScreens(): Observable<IOOHScreenResponse> {
    return this.http.get<IOOHScreenResponse>(
      ApiConstants.superAdminOOHScreens
    );
  }

  // ✅ API TO FETCH OOH SCREEN BY ID (optional but useful)
  getOOHScreenById(id: number): Observable<IOOHScreen> {
    return this.http.get<IOOHScreen>(ApiConstants.superAdminOOHScreens + `${id}/`);
  }

  getBusinessScreenById(id: number): Observable<IAdminScreenDetail> {
    return this.http.get<IAdminScreenDetail>(ApiConstants.superAdminScreenDetails + `${id}/`);
  }

  // ✅ API TO APPROVE SCREEN
  approveScreen(screen_id: number): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      ApiConstants.superAdminOOHScreens + `${screen_id}/`,
      {
        "status": "APPROVED"
      }
    );
  }

  // ✅ API TO REJECT SCREEN
  rejectScreen(screen_id: number): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      ApiConstants.superAdminOOHScreens + `${screen_id}/`,
      {
        status: 'REJECTED'
      }
    );
  }

}
